import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

// Jds
import {
  ActionButton,
  Button,
  Container,
  Icon,
  Notifications,
  Skeleton,
  Text,
} from "@jds/core";

// Mui

// Local
import AddButton from "../components/UI/Buttons/AddButton";
import JdsModal from "../components/UI/JdsModal";
import FolderForm from "../components/UI/Form/FolderForm";
import EmptyState from "../components/NoData/EmptyState";
import AlbumCard from "../components/UI/Cards/AlbumCard";
import useApiHttp from "../hooks/use-http";
import SuccessModal from "../components/UI/SuccessModal/SuccessModal";
import PageLoader from "../components/UI/Loader/PageLoader";
import { baseToImg } from "../util/helper";
import Loader from "../components/UI/Loader/Loader";
import {
  setActiveModalClose,
  setPlanModalClose,
  setPremiumPlanId,
} from "../store/state-slices/plans";
import IconRocket from "../assets/svg/ic_enterpreneurial.svg";
import { useDispatch, useSelector } from "react-redux";
import ActiveAlertContainer from "../components/UI/ActiveAlertContainer/ActiveAlertContainer";

export default function Albums() {
  const { id: eventId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { eventDetails } = useSelector((state) => state.eventDetails);
  const [planActive, setPlanActive] = useState(true);
  const [planActiveMsg, setPlanActiveMsg] = useState("");
  const [folderList, setFolderList] = useState([]);
  const [apiSuccess, setApiSuccess] = useState(true);
  const [isSuccessModalClosed, setSuccessModalClose] = useState(true);
  const [lastPage, setLastPage] = useState(0);
  const [editData, setEditData] = useState({});
  const [isEditModalClose, setEditModalClose] = useState(true);
  const [isDeleteModalClose, setDeleteModalClose] = useState(true);
  const [isDeleteThumbnailModalClose, setDeleteThumbnailModalClose] =
    useState(true);
  const [isCreateModalClose, setCreateModalClose] = useState(true);
  const [isWatermarkAvailable, setIsWatermarkAvailable] = useState(false);
  const [page, setPage] = useState(0);
  const location = useLocation();
  const { isAdmin } = useSelector((state) => state.role);
  // API calls
  const { sendRequest: getFoldersReq, isLoading: isFolGeting } = useApiHttp();
  const { sendRequest: addFolderRequest, success: folderSubmitSuccess } =
    useApiHttp();
  const { sendRequest: deleteFolderRequest, isLoading: isDeleting } =
    useApiHttp();
  const {
    sendRequest: deleteThumbnailRequest,
    isLoading: isDeletingThumbNail,
  } = useApiHttp();
  const { sendRequest: getWatermarkReq, isLoading: waterReqGeting } =
    useApiHttp();

  const { sendRequest: getEventDetReq, isLoading: eventDetReqGeting } =
    useApiHttp();

  //Get Folder
  const getFoldersHandler = () => {
    getFoldersReq(
      {
        url: `event-folders/get-event-folder/${eventId}?page=${page}&size=25`,
      },
      null,
      (data) => {
        if (page == 0) {
          setFolderList(data.data.results);
          setLastPage(data?.data.lastPage);
        } else {
          setFolderList((pre) => [...pre, ...data.data.results]);
          setLastPage(data?.data.lastPage);
        }
      },
      (err, data) => {
        if (data?.statusCode == 402 || data?.statusCode == 403) {
          setPlanActive(false);
          if (eventDetails?.userRole == "ADMIN") {
            setPlanActiveMsg(data?.message);
          } else {
            setPlanActiveMsg(
              "The subscription for this event organizer has ended. Please contact the event organizer directly for more information."
            );
          }
        } else {
          Notifications.toast.error({
            id: "get-folder",
            title: data?.message,
          });
        }
      }
    );
  };

  // Add Folder
  const formAddHandler = (data) => {
    addFolderRequest(
      {
        url: `event-folders/create-folder`,
        method: "POST",
        body: data,
      },
      null,
      (data) => {
        Notifications.toast.success({
          title: data?.message || "Folder created successfully",
          id: "create-folder",
        });
        if (page !== 0) {
          setPage(0);
        } else {
          getFoldersHandler();
        }
        setCreateModalClose(true);
      },
      (err, res) => {
        Notifications.toast.error({ id: "create-folder", title: res?.message });
        setCreateModalClose(true);
      }
    );
  };

  // Edit Folder
  const folderUpdateHandler = (data, folderId) => {
    addFolderRequest(
      {
        url: `event-folders/update-folder/${folderId}`,
        method: "PUT",
        body: data,
      },
      null,
      (data) => {
        console.log("is1234", data);
        setEditModalClose(true);
        Notifications.toast.success({
          id: "update-folder",
          title: data?.message,
        });
        setFolderList((pre) =>
          pre.map((item) =>
            editData.id == item.id
              ? {
                  ...item,
                  name: data?.data?.name,
                  date: data?.data?.date,
                  isPremium: data?.data?.isPremium,
                }
              : item
          )
        );
      },
      (err, data) => {
        setEditModalClose(true);
        Notifications.toast.error({
          id: "update-folder",
          title: data?.message,
        });
      }
    );
  };

  // Delete Folder
  const deleteFolderHandler = (id) => {
    deleteFolderRequest(
      {
        url: `event-folders/delete-folder`,
        method: "DELETE",
        body: {
          id,
          eventId,
        },
      },
      null,
      (data) => {
        setDeleteModalClose(true);
        Notifications.toast.success({
          title: data.message,
          id: "delete-folder",
        });
        setFolderList((pre) => pre.filter((item) => item.id !== editData.id));
      },
      (err, data) => {
        setDeleteModalClose(true);
        Notifications.toast.error({
          title: data.message,
          id: "delete-folder",
        });
      }
    );
  };

  // Delete Thumbnail
  const deleteThumbnailHandler = (editData) => {
    console.log(editData);
    deleteThumbnailRequest(
      {
        url: `event/delete-thumbnail?folderId=${editData.id}`,
        method: "DELETE",
      },
      null,
      (data) => {
        setFolderList((pre) =>
          pre.map((item) =>
            editData.id == item.id
              ? {
                  ...item,
                  thumbnailImage: null,
                }
              : item
          )
        );
        setDeleteThumbnailModalClose(true);
        Notifications.toast.success({
          title: data.message,
          id: "delete-folder-thumbnail",
        });
      },
      (err, data) => {
        setDeleteThumbnailModalClose(true);
        Notifications.toast.error({
          title: data.message,
          id: "delete-folder-thumbnail",
        });
      }
    );
  };

  // Watermark details
  const getWatermarkDetails = () => {
    getWatermarkReq(
      {
        url: `watermark/event/${eventId}`,
        base: "MEDIA",
      },
      null,
      (data) => {
        data.statusCode == 200
          ? setIsWatermarkAvailable(true)
          : setIsWatermarkAvailable(false);
      },
      (err, data) => {
        Notifications.toast.error();
      }
    );
  };
  // Watermark details
  const getEventDetails = () => {
    getEventDetReq(
      {
        url: `event/get-event/${eventId}`,
      },
      null,
      (data) => {
        dispatch(setPremiumPlanId(data?.data?.planId));
      },
      (err, data) => {
        Notifications.toast.error();
      }
    );
  };

  useEffect(() => {
    const handleScroll = (e) => {
      const scrollHeight = document?.querySelector("#root-layout").scrollHeight;
      const currentHeight =
        document?.querySelector("#root-layout").scrollTop + window.innerHeight;

      if (
        currentHeight + 300 >= scrollHeight &&
        page < lastPage &&
        !isFolGeting
      ) {
        setPage(page + 1);
      }
    };
    document
      ?.querySelector("#root-layout")
      ?.addEventListener("scroll", handleScroll);
    return () => {
      document
        ?.querySelector("#root-layout")
        ?.removeEventListener("scroll", handleScroll);
    };
  }, [page, lastPage, isFolGeting]);

  useEffect(() => {
    getFoldersHandler();
  }, [page]);

  useEffect(() => {
    getWatermarkDetails();
    getEventDetails();
  }, []);

  if (!planActive) {
    return <ActiveAlertContainer message={planActiveMsg} />;
  }
  return (
    <>
      <Container
        horizontalAlign="space-between"
        fullWidth
        style={{
          paddingTop: "32px",
          marginTop: "-32px",
          position: "sticky",
          top: "72px",
          backgroundColor: "white",
          paddingBottom: "16px",
          zIndex: 30,
        }}
      >
        <Container direction="column" gap={14}>
          <Text text="Albums" appearance="heading-xs" />
        </Container>

        <Container gap={"16px"}>
          {isAdmin && (
            <ActionButton
              kind="secondary"
              label="Share Photos"
              icon="IcShare"
              size="medium"
              onClick={() => {
                navigate(`/home/events/share/${eventId}`);
                // navigate(`/home/events/guests/${eventId}`, {
                //   state: { requestAccess: true },
                // });
              }}
            />
          )}
          <ActionButton
            kind="primary"
            appearance="normal"
            label="New Folder"
            icon="IcAdd"
            onClick={() => {
              setCreateModalClose(false);
              setApiSuccess(false);
            }}
          />
        </Container>

        <JdsModal
          header="Add Folder"
          size="m"
          close={isCreateModalClose}
          onClose={() => {
            setCreateModalClose(true);
          }}
        >
          {!isCreateModalClose && (
            <FolderForm
              isWatermarkAvailable={isWatermarkAvailable}
              onSubmit={(data) => {
                setApiSuccess(false);
                setPage(0);
                formAddHandler(data);
              }}
              apiSuccess={apiSuccess}
            />
          )}
        </JdsModal>
      </Container>

      <div>
        <Container
          fullWidth
          horizontalAlign="start"
          gap={16}
          style={{ marginTop: "32px", flexWrap: "wrap" }}
        >
          {/* {isLoading ? (
          <Skeleton shape="square" width="184" animated />
        ) :  */}
          {folderList?.length > 0 ? (
            folderList.map((data, i) => (
              <AlbumCard
                key={i}
                data={data}
                onClick={() => {
                  navigate(`${location.pathname}/photos/${data.id}`, {
                    state: { albumName: data?.name },
                  });
                }}
                setEditData={setEditData}
                setEditModalClose={setEditModalClose}
                setDeleteModalClose={setDeleteModalClose}
                setDeleteThumbnailModalClose={setDeleteThumbnailModalClose}
              />
            ))
          ) : (
            <EmptyState
              title="No Folders"
              subtitle="Get started by creating a folder."
              action={false}
              mt={6}
            />
          )}
          {isFolGeting && page !== 0 && <Loader size={"small"} />}
        </Container>
      </div>

      {/* Edit folder  */}

      <JdsModal
        header="Edit Folder"
        size="m"
        close={isEditModalClose}
        onClose={() => {
          setEditModalClose(true);
        }}
      >
        {!isEditModalClose && (
          <FolderForm
            isWatermarkAvailable={isWatermarkAvailable}
            editData={editData}
            onSubmit={(formData) => folderUpdateHandler(formData, editData?.id)}
          />
        )}
      </JdsModal>

      {/* Delete Conformation */}
      <JdsModal
        size="m"
        header="Are you sure you want to delete this folder?"
        kind="dialog"
        primaryCTA={{
          title: "Okay",
        }}
        secondaryCTA={{
          title: "Cancel",
        }}
        close={isDeleteModalClose}
        onClose={() => {
          setDeleteModalClose(true);
        }}
        onPrimaryClick={() => {
          deleteFolderHandler(editData?.id);
        }}
        onSecondaryClick={() => setDeleteModalClose(true)}
        primaryCtaDisabled={isDeleting}
      />

      <SuccessModal
        close={isSuccessModalClosed}
        subtitle="Your folder has been created successfully."
        onClose={() => {
          setSuccessModalClose(true);
        }}
      />
      <JdsModal
        size="m"
        header="Are you sure you want to delete this thumbnail?"
        kind="dialog"
        primaryCTA={{
          title: "Okay",
        }}
        secondaryCTA={{
          title: "Cancel",
        }}
        close={isDeleteThumbnailModalClose}
        onClose={() => {
          setDeleteThumbnailModalClose(true);
        }}
        onPrimaryClick={() => {
          deleteThumbnailHandler(editData);
        }}
        onSecondaryClick={() => setDeleteThumbnailModalClose(true)}
        primaryCtaDisabled={isDeletingThumbNail}
      />
    </>
  );
}
